import { render } from "./App.vue?vue&type=template&id=42587d25"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=42587d25&lang=css"

import exportComponent from "C:\\Users\\5300855\\git\\eai-3535389-apac-peace-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__